export async function analyzeImageWithAI(file: File, task?: string) {
  const apiKey = import.meta.env.VITE_OPENROUTER_API_KEY;
  const model = "anthropic/claude-sonnet-4";
  const url = "https://openrouter.ai/api/v1/chat/completions";
  const toBase64 = (file: File) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve((reader.result as string).split(',')[1]);
      reader.onerror = error => reject(error);
    });
  const base64 = await toBase64(file);

  let prompt = "";
  if (task === 'manipulation') {
    prompt = "Analyze this image for manipulation. Provide a brief, direct response with: 1) Main finding (manipulated/not manipulated), 2) Key evidence, 3) Confidence score (0-100%). Keep it under 3 sentences.";
  } else if (task === 'ai-generated') {
    prompt = "Analyze this image for AI generation. Provide a brief, direct response with: 1) Main finding (AI-generated/likely real), 2) Key evidence, 3) Confidence score (0-100%). Keep it under 3 sentences.";
  } else {
    prompt = "Analyze this image. Provide a brief, direct response with key findings. Keep it under 3 sentences.";
  }

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      model,
      messages: [
        {
          role: "user",
          content: [
            { type: "text", text: prompt },
            { type: "image_url", image_url: { url: `data:image/jpeg;base64,${base64}` } }
          ]
        }
      ]
    }),
  });

  if (!response.ok) throw new Error("Failed to analyze image with AI");
  const data = await response.json();
  return data.choices?.[0]?.message?.content || "No answer from AI";
} 